import * as ScrollAreaRadix from '@radix-ui/react-scroll-area';
import React from 'react';

const ScrollAreaInner = ({ children }: React.PropsWithChildren<{}>) => (
  <ScrollAreaRadix.Root className="h-full w-full mr-[2px] overflow-hidden" scrollHideDelay={200}>
    <ScrollAreaRadix.Viewport className="w-full h-full [&>div]:!block [&>div]:!min-w-0">{children}</ScrollAreaRadix.Viewport>
    <ScrollAreaRadix.Scrollbar className="flex w-[5px] mr-[2px]" orientation="vertical">
      {/* content-light at 50% alpha — kept in sync with the global native
          scrollbar colour in apps/web/public/globals.css so native and
          custom scrollbars share one subtle resting tone across the app. */}
      <ScrollAreaRadix.Thumb className="relative flex-1 rounded-radius-lg bg-content-light/50" />
    </ScrollAreaRadix.Scrollbar>
    <ScrollAreaRadix.Scrollbar className="flex w-[5px]" orientation="horizontal">
      <ScrollAreaRadix.Thumb className="relative flex-1 rounded-radius-lg bg-content-light/50" />
    </ScrollAreaRadix.Scrollbar>
    <ScrollAreaRadix.Corner />
  </ScrollAreaRadix.Root>
);

ScrollAreaInner.displayName = 'ScrollArea';

const ScrollArea = React.memo(ScrollAreaInner);

export { ScrollArea };
